export default "__VITE_ASSET__BPMa_wwx__"